import TopicsList from "../../components/forums/topics/TopicsList"

export const ForumPage = () => {

    return (
        <TopicsList></TopicsList>
    )
}